module.exports = __webpack_public_path__ + "img/arrow_right_3.6a11b927.svg";